<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<agm-map
  *ngIf="!isPay"
  id="AgmMap"
  #AgmMap
  [ngClass]="isHeight ? 'nvc-height-map' : 'nvc-map'"
  [latitude]="lat"
  [longitude]="lng"
  [zoom]="zoom"
  (mapClick)="mapClicked($event)"
>
  <agm-marker
    *ngFor="let m of markers"
    [latitude]="m.lat"
    [longitude]="m.lng"
    [markerDraggable]="true"
    (dragEnd)="markerDragEnd($event)"
  ></agm-marker>
</agm-map>

<div id="searchBox" class="header" fxLayout="column" *ngIf="!isPay">
  <img
    (click)="navigateBack()"
    id="e2e-maps-back"
    class="backbutton ws-cursor-pointer"
    src="assets/icons/Backbutton.svg"
  />
  <mat-form-field class="search-box" fxFlex appearance="outline" color="warn">
    <mat-icon matPrefix (click)="geolocation()">gps_fixed</mat-icon>
    <mat-label>Search</mat-label>
    <input
      class="search-input"
      matInput
      [(ngModel)]="tempAddress"
      placeholder="Search"
      (ngModelChange)="moveSearchResults()"
      (focus)="moveSearchResults()"
      #keyword
    />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</div>
<ng-container *ngIf="!showPlaceholder">
  <input
    type="text"
    placeholder="{{ addressPlaceholder }}"
    [ngClass]="
      isCompany
        ? 'nvc-input-tag-company'
        : editAddress
        ? 'nvc-input-tag-edit'
        : 'nvc-input-tag'
    "
    matInput
    [(ngModel)]="addressPay"
    #keyword
    (ngModelChange)="addressLine.emit($event)"
    *ngIf="isPay && !hideDisplay"
    [disabled]="isCompany"
  />
</ng-container>

<div class="container" *ngIf="isHeight">
  <!--    <p *ngIf='selectedMarker'>Lat: {{ selectedMarker.lat }} Lng: {{ selectedMarker.lng }}</p>-->
  <form action="" fxLayout="column">
    <div class="input-row">
      <mat-form-field fxFlex color="warn" appearance="outline">
        <mat-label class="notranslate" i18n>Enter Address</mat-label>
        <textarea
          id="e2e-maps-address"
          matInput
          value="{{ location }}"
          (change)="location = $event.target.value"
        ></textarea>
      </mat-form-field>
    </div>

    <!-- <label class="notranslate" i18n>Save as</label>
        <div class="input-row" fxLayout="row" fxLayoutAlign="none" fxLayout.lt-md="column" fxLayoutGap="0px"
             fxLayoutGap.lt-md="0px">
            <div fxFlex fxLayout="row" fxLayoutAlign="none start" fxLayoutGap="25px">
                <label class="custom-radio-button-container" fxFlex="20%">
                    <input type="radio" checked="checked" name="the-options" value="home">
                    <span class="custom-radio-button" fxLayout="row">
                        <mat-icon fxFlex="35%" fxLayoutAlign="start start">home</mat-icon><span fxFlex class="notranslate" i18n>Home</span>
                    </span>
                </label>
                <label class="custom-radio-button-container" fxFlex="20%">
                    <input type="radio" name="the-options" value="work">
                    <span class="custom-radio-button" fxLayout="row">
                        <mat-icon fxFlex="35%" fxLayoutAlign="start start">work</mat-icon><span fxFlex class="notranslate" i18n>Work</span>
                    </span>
                </label>
                <label class="custom-radio-button-container" fxFlex>
                    <input type="radio" name="the-options" value="others">
                    <span class="custom-radio-button" fxLayout="row">
                        <span fxFlex class="notranslate" i18n>Others</span>
                    </span>
                </label>
            </div>

            <mat-form-field fxFlex color="warn">
                <input matInput>
            </mat-form-field>
        </div> -->
    <button
      id="e2e-maps-confirm"
      (click)="save()"
      mat-button
      class="notranslate"
      i18n
    >
      CONFIRM CURRENT LOCATION
    </button>
  </form>
</div>

<div class="container_m" *ngIf="!(isHeight || isPay)">
  <!--    <p *ngIf='selectedMarker'>Lat: {{ selectedMarker.lat }} Lng: {{ selectedMarker.lng }}</p>-->
  <form action="" fxLayout="column">
    <div class="input-row">
      <mat-form-field fxFlex color="warn">
        <mat-label class="notranslate" i18n>Enter Address</mat-label>
        <textarea
          id="e2e-maps-address"
          matInput
          value="{{ location }}"
        ></textarea>
      </mat-form-field>
    </div>

    <!-- <label class="notranslate" i18n>Save as</label>
        <div class="input-row" fxLayout="row" fxLayoutAlign="none" fxLayout.lt-md="column" fxLayoutGap="0px"
             fxLayoutGap.lt-md="0px">
            <div fxFlex fxLayout="row" fxLayoutAlign="none start" fxLayoutGap="25px">
                <label class="custom-radio-button-container" fxFlex="20%">
                    <input type="radio" checked="checked" name="the-options" value="home">
                    <span class="custom-radio-button" fxLayout="row">
                        <mat-icon fxFlex="35%" fxLayoutAlign="start start">home</mat-icon><span fxFlex class="notranslate" i18n>Home</span>
                    </span>
                </label>
                <label class="custom-radio-button-container" fxFlex="20%">
                    <input type="radio" name="the-options" value="work">
                    <span class="custom-radio-button" fxLayout="row">
                        <mat-icon fxFlex="35%" fxLayoutAlign="start start">work</mat-icon><span fxFlex class="notranslate" i18n>Work</span>
                    </span>
                </label>
                <label class="custom-radio-button-container" fxFlex>
                    <input type="radio" name="the-options" value="others">
                    <span class="custom-radio-button" fxLayout="row">
                        <span fxFlex class="notranslate" i18n>Others</span>
                    </span>
                </label>
            </div>

            <mat-form-field fxFlex color="warn">
                <input matInput>
            </mat-form-field>
        </div> -->
    <button
      id="e2e-maps-confirm"
      (click)="save()"
      mat-button
      class="notranslate"
      i18n
    >
      CONFIRM CURRENT LOCATION
    </button>
  </form>
</div>
<ng-container *ngIf="showPlaceholder">
  <mat-form-field appearance="outline" class="sc-mat-form-input" id="searchBox">
    <mat-label
      class="sc-input-label"
      [ngStyle]="{ 'font-size.px': fontSize ? fontSize : 16 }"
      >{{ addressPlaceholder }}</mat-label
    >
    <input
      type="text"
      placeholder=""
      [ngClass]="
        isCompany
          ? 'nvc-input-tag-company'
          : editAddress
          ? 'nvc-input-tag-edit nvc-padding-none'
          : 'nvc-input-tag'
      "
      matInput
      [(ngModel)]="addressPay"
      #keyword
      (ngModelChange)="moveSearchResults($event)"
      (focus)="moveSearchResults()"
      *ngIf="isPay && !hideDisplay && showPlaceholder"
      [disabled]="isCompany"
    />
    <mat-icon
      matSuffix
      matTooltip="Current Location"
      class="material-icons-outlined nvc-gps-icon ws-cursor-pointer"
      (click)="getCurrentAddress()"
      >gps_fixed</mat-icon
    >
  </mat-form-field>
</ng-container>
